import React, { Fragment } from 'react';

import { useBlockName } from '@wp-block-builder/editor/hooks';
import { type TBlock } from '@wp-block-builder/package';
import { SectionBlockLayout, useIsLoopIteration } from '@wp-block-builder/stores/BlockLayoutStore';
import AddContainerBlockButton from '@wp-block-builder/views/EditableMessage/components/AddBlockButton/AddContainerBlockButton';
import AddContainerBlockPlaceholderButton from '@wp-block-builder/views/EditableMessage/components/AddBlockButton/AddContainerBlockPlaceholderButton';
import { useEditableBlocks } from '@wp-block-builder/views/EditableMessage/hooks';

import BlockPlaceholder from '../helpers/BlockPlaceholder';

type EditableCanvasProps = {
  blocksArrayName: string;
  BlockComponent: (props: { block: TBlock }) => JSX.Element;
};
export function EditableCanvas({ blocksArrayName, BlockComponent }: EditableCanvasProps) {
  const isLoopIteration = useIsLoopIteration();
  const blocks = useEditableBlocks(blocksArrayName);

  const renderAddButton = (index?: number) => {
    if (isLoopIteration) {
      return null;
    }
    return <AddContainerBlockButton blocksArrayName={blocksArrayName} index={index} />;
  };

  if (blocks.length === 0) {
    if (isLoopIteration) {
      return <BlockPlaceholder type="Container" />;
    }
    return <AddContainerBlockPlaceholderButton blocksArrayName={blocksArrayName} />;
  }
  return (
    <>
      {blocks.map((block, index) => (
        <Fragment key={`${block.id}-${index}`}>
          {renderAddButton(index)}
          <BlockComponent block={block} />
        </Fragment>
      ))}
      {renderAddButton()}
    </>
  );
}

type Props = {
  block: Extract<TBlock, { type: 'Container' }>;
  BlockComponent: (props: { block: TBlock }) => JSX.Element;
};
export default function ContainerEditableBlock({ block, BlockComponent }: Props) {
  const name = useBlockName(block.id);
  return (
    <SectionBlockLayout>
      <EditableCanvas blocksArrayName={`${name}.props.blocks`} BlockComponent={BlockComponent} />
    </SectionBlockLayout>
  );
}
